import styled from "styled-components";
import DateOption1 from "../Components/DateOption1.jsx";
import DropdownOption from "../Components/DropdownOption.jsx";
import { ReactComponent as IconSearch } from "../Images/icon_search.svg";

const MemberManageFilters = ({
  clickActive,
  clickInput,
  canManageDepartmentAndRelation,
  dropDownDepartmentList,
  startTime,
  endTime,
  onSetStatus,
  onSetClickActive,
  onSetSearchWord,
  onSetClickInput,
  onSearch,
  onSetDepartment,
  onSetSort,
  onSetNation,
  onSetStartTime,
  onSetEndTime,
}) => {
  const handleResetDateFilter = () => {
    onSetStartTime(new Date());
    onSetEndTime(new Date());
    window.location.reload();
  };

  return (
    <>
      <StatusTabs>
        <StatusTabButton
          $selected={clickActive}
          onClick={() => {
            onSetClickActive(true);
            onSetStatus("active");
          }}
        >
          <p>활성 구성원</p>
        </StatusTabButton>
        <StatusTabButton
          $selected={!clickActive}
          onClick={() => {
            onSetClickActive(false);
            onSetStatus("inactive");
          }}
        >
          <p>비활성 구성원</p>
        </StatusTabButton>
        <StatusTabsDivider />
      </StatusTabs>

      <SearchFilterRow>
        <MemberSearchBox $isFocused={clickInput}>
          <input
            placeholder="닉네임"
            onChange={(e) => onSetSearchWord(e.target.value)}
            onClick={() => onSetClickInput(true)}
            onBlur={() => onSetClickInput(false)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSearch();
              }
            }}
          />
          <SearchIconButton onClick={onSearch} />
        </MemberSearchBox>
        <FilterDropdownGroup>
          {canManageDepartmentAndRelation && (
            <DropdownOption
              title="전체 부서"
              dropdown_list={["없음", ...dropDownDepartmentList]}
              optionChange={onSetDepartment}
            />
          )}
          <DropdownOption
            title="정렬"
            dropdown_list={["등록순", "랭킹순"]}
            optionChange={onSetSort}
          />
          <DropdownOption
            title="전체 국가"
            dropdown_list={["한국", "중국", "미국", "일본", "인도", "싱가포르"]}
            optionChange={onSetNation}
          />
        </FilterDropdownGroup>
      </SearchFilterRow>

      <DateFilterCard>
        <DateFilterTitle className="medium-text">기간별 랭킹 조회</DateFilterTitle>
        <DateFilterControls>
          <DateOption1
            width="145px"
            height="44px"
            fontSize="14px"
            gap="10px"
            startDate={startTime}
            endDate={endTime}
            setStartDate={onSetStartTime}
            setEndDate={onSetEndTime}
            type="search"
          />
          <DateFilterAction onClick={onSearch}>조회</DateFilterAction>
          <DateFilterResetAction onClick={handleResetDateFilter}>
            초기화
          </DateFilterResetAction>
        </DateFilterControls>
      </DateFilterCard>
    </>
  );
};

const StatusTabs = styled.div.attrs({ className: "hrz-wrapper" })`
  margin-top: 20px;
`;

const StatusTabButton = styled.div.attrs({ className: "activeBtn center" })`
  background-color: ${(props) => (props.$selected ? "#ffffff" : "#eeeeee")};
  border-top: ${(props) => (props.$selected ? "1px solid #1167ed" : "none")};
  border-left: ${(props) => (props.$selected ? "1px solid #1167ed" : "none")};
  border-right: ${(props) => (props.$selected ? "1px solid #1167ed" : "none")};
  border-bottom: ${(props) =>
    props.$selected ? "none" : "1px solid #1167ed"};

  > p {
    color: ${(props) => (props.$selected ? "#1167ed" : "#b0b0b0")};
  }
`;

const StatusTabsDivider = styled.div`
  width: 100%;
  max-width: 1239px;
  height: 56px;
  border-bottom: 1px solid #1167ed;
`;

const SearchFilterRow = styled.div.attrs({ className: "hrz-wrapper" })`
  margin-top: 20px;
`;

const MemberSearchBox = styled.div.attrs({ className: "searchBox" })`
  box-shadow: ${(props) =>
    props.$isFocused ? "inset 0 0 0 1px #1167ed" : "0 0 0 1px #e4e4e4"};
`;

const SearchIconButton = styled(IconSearch)`
  margin-left: 4px;
  cursor: pointer;
`;

const FilterDropdownGroup = styled.div`
  margin-left: auto;
  display: flex;
`;

const DateFilterCard = styled.div`
  padding: 20px;
  border-radius: 20px;
  background-color: #f5f5f5;
  box-shadow: inset 0 0 0 1px #e4e4e4;
  margin-top: 20px;
`;

const DateFilterTitle = styled.p`
  font-size: 18px;
`;

const DateFilterControls = styled.div`
  display: flex;
  margin-top: 2px;
`;

const DateFilterAction = styled.div.attrs({
  className: "blueBtn-90x44 center",
})`
  margin: 8px 8px 0 8px;
`;

const DateFilterResetAction = styled.div.attrs({
  className: "blueBorderBtn-90x44 center",
})`
  margin-top: 8px;
`;

export default MemberManageFilters;
